import { Box, Stack } from "@mui/material"
import React, { Fragment } from "react"
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon"
import { useTheme } from "@emotion/react"
import { Password } from "@phosphor-icons/react"
import { GenericResendVerificationForm } from "../generic/GenericResendVerificationForm"
import { NeedHelp } from "../generic/GenericDialogFooter"

export const SendResetPasswordForm = ({ email }) => {
  const theme = useTheme();
  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon>
          <Password size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={'center'}>
        <GenericResendVerificationForm email={email} />
        <NeedHelp />
      </Stack>
    </Fragment>
  )
}